<template>
	<div class="feedback-page">
		<el-card shadow="never">
			<el-form :model="queryParams" inline label-width="85px">
				<el-form-item>
					<el-select v-model="queryParams.status" placeholder="全部状态" clearable @change="fetchList(true)">
						<el-option label="全部状态" :value="null"></el-option>
						<el-option label="已提交" :value="0"></el-option>
						<el-option label="处理中" :value="1"></el-option>
						<el-option label="处理完成" :value="10"></el-option>
						<el-option label="进入需求库" :value="99"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryParams.type" placeholder="全部反馈" clearable @change="fetchList(true)">
						<el-option label="全部反馈" value=""></el-option>
						<el-option label="功能建议" value="FUNCTION"></el-option>
						<el-option label="BUG问题" value="BUG"></el-option>
						<el-option label="体验优化" value="OPTIMIZE"></el-option>
						<el-option label="其他" value="OTHER"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryParams.userType" placeholder="全部平台" clearable @change="fetchList(true)">
						<el-option label="全部平台" value=""></el-option>
						<el-option label="学校" value="2"></el-option>
						<el-option label="学生" value="3"></el-option>
						<el-option label="家长" value="4"></el-option>
						<el-option label="教育局" value="5"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="机构名称">
					<el-input v-model="queryParams.orgName" placeholder="机构名称搜索" @keyup.enter.native="onOrgNameSearch"
						@blur="onOrgNameSearch"></el-input>
				</el-form-item>
				<!-- <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="fetchList(true)">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item> -->
			</el-form>
		</el-card>

		<el-card shadow="never" class="mt16">
			<el-table :data="tableData" border stripe v-loading="loading">
				<el-table-column label="ID" prop="id" width="80"></el-table-column>
				<el-table-column label="机构" prop="orgName" width="140" show-overflow-tooltip></el-table-column>
				<el-table-column label="反馈标题" prop="name" min-width="180" show-overflow-tooltip></el-table-column>
				<el-table-column label="建议类型" prop="type" width="110">
					<template slot-scope="{row}">
						<span>{{ getTypeName(row.type) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="平台" prop="userType" width="90">
					<template slot-scope="{row}">
						<span>{{ getUserTypeName(row.userType) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" prop="status" width="120">
					<template slot-scope="{row}">
						<el-tag :type="getStatusTag(row.status)">{{ getStatusName(row.status) }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="页面路径" prop="url" width="160" show-overflow-tooltip></el-table-column>
				<el-table-column label="提交时间" prop="submitTime" width="180">
					<template slot-scope="{row}">
						{{ formatTs(row.submitTime) }}
					</template>
				</el-table-column>
				<el-table-column label="处理时间" prop="feedbackTime" width="180">
					<template slot-scope="{row}">
						{{ formatTs(row.feedbackTime)||"--" }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="140">
					<template slot-scope="{row}">
						<el-button type="text" size="small" @click="openDetail(row)" v-if="row.status!=10">处理</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination class="mt16" @current-change="handleCurrentChange" :current-page="queryParams.pageNum"
				:page-size="queryParams.pageSize" layout="total, prev, pager, next, jumper"
				:total="total"></el-pagination>
		</el-card>

		<!-- 详情+处理弹窗 -->
		<el-dialog title="反馈详情与处理" :visible.sync="dialogVisible" width="60%" append-to-body center>
			<div style="height: 60vh;overflow-y: auto;">
				<div v-if="currentRow">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="机构名称">{{ currentRow.orgName||"--" }}</el-descriptions-item>
						<el-descriptions-item label="建议类型">{{ getTypeName(currentRow.type) }}</el-descriptions-item>
						<el-descriptions-item label="平台">{{ getUserTypeName(currentRow.userType) }}</el-descriptions-item>
						<el-descriptions-item label="当前状态">
							<el-tag :type="getStatusTag(currentRow.status)">{{ getStatusName(currentRow.status) }}</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="页面路径">{{ currentRow.url||"--" }}</el-descriptions-item>
						<el-descriptions-item label="提交时间">{{ formatTs(currentRow.submitTime) }}</el-descriptions-item>
						<el-descriptions-item label="反馈标题" :span="2">{{ currentRow.name }}</el-descriptions-item>
						<el-descriptions-item label="用户反馈内容" :span="2">
							<pre style="white-space:pre-wrap;margin:0;">{{ currentRow.text }}</pre>
						</el-descriptions-item>
						<el-descriptions-item label="反馈截图" :span="2" v-if="currentRow.url">
							<el-image :src="currentRow.screenshotUrl" :preview-src-list="[currentRow.screenshotUrl]"
								style="width:200px;height:auto;"></el-image>
						</el-descriptions-item>
						<el-descriptions-item label="历史处理回复" :span="2">
							<div v-if="currentRow.feedbackText">
								<div style="background:#f5f7fa;padding:10px;border-radius:4px;">
									<div>处理内容：{{ currentRow.feedbackText }}</div>
									<div style="font-size:12px;color:#999;margin-top:6px;">
										处理时间：{{ formatTs(currentRow.feedbackTime) }}</div>
								</div>
							</div>
							<div v-else>暂无处理记录</div>
						</el-descriptions-item>
					</el-descriptions>
				
					<el-divider>执行处理</el-divider>
					<el-form :model="processForm" label-width="90px">
						<el-form-item label="设置状态">
							<el-select v-model="processForm.status">
								<el-option label="处理中" :value="1"></el-option>
								<el-option label="处理完成" :value="10"></el-option>
								<el-option label="进入需求库" :value="99"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="处理备注">
							<el-input v-model="processForm.feedbackText" type="textarea" :rows="5"
								placeholder="填写处理备注"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" style="text-align:center;">
				<el-button @click="dialogVisible=false">取消</el-button>
				<el-button type="primary" @click="submitProcess">提交处理</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "userFeedback",
		data() {
			return {
				loading: false,
				total: 0,
				tableData: [],
				lastOrgName: "",
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					status: null,
					type: "",
					userType: "",
					orgName: "",
				},
				dialogVisible: false,
				currentRow: null,
				processForm: {
					id: null,
					status: 1,
					feedbackText: "",
					feedbackUserId:"",
				},
				login: null
			}
		},
		mounted() {
			
		},
		created() {
			// 初始化时记录机构名称初始值
			this.lastOrgName = this.queryParams.orgName
			this.fetchList(true)
		},
		methods: {
			// 机构名称：回车或失焦时触发，对比前后值，不一致才查询
			onOrgNameSearch() {
				const current = this.queryParams.orgName || ""
				const last = this.lastOrgName || ""
				if (current === last) {
					return
				}
				this.lastOrgName = current
				this.fetchList(true)
			},

			async fetchList(reset = false) {
				if (reset) {
					this.queryParams.pageNum = 1
				}
				this.loading = true
				try {
					const params = {
						pageNum: this.queryParams.pageNum,
						pageSize: this.queryParams.pageSize,
						orgName: this.queryParams.orgName || null,
						userType: this.queryParams.userType || null,
						type: this.queryParams.type || null,
						status: this.queryParams.status
					}
					const res = await this.API.get(this.API.fileurl.getSuggestPage, params)
					const apiData = res?.data?.data || {}
					this.tableData = Array.isArray(apiData.records) ? apiData.records : []
					this.total = apiData.total || 0
				} catch (e) {
					console.error(e)
				} finally {
					this.loading = false
				}
			},

			resetQuery() {
				this.queryParams = {
					pageNum: 1,
					pageSize: 10,
					status: null,
					type: "",
					userType: "",
					orgName: "",

				}
				this.lastOrgName = ""
				this.fetchList(true)
			},

			handleSizeChange(val) {
				this.queryParams.pageSize = val
				this.fetchList(true)
			},
			handleCurrentChange(val) {
				this.queryParams.pageNum = val
				this.fetchList(false)
			},
			async openDetail(row) {
				this.currentRow = row
				if (this.currentRow.url) {
					this.currentRow.screenshotUrl =await this.$oss.getDownloadUrl(row.url)
				}else{
					this.currentRow.screenshotUrl=null
				}
				this.processForm = {
					id: row.id,
					status: [0, 1, 10, 99].includes(row.status) ? row.status : 1,
					feedbackText: "",
					feedbackUserId:localStorage.getItem('userId')
				}
				this.dialogVisible = true
			},
			async submitProcess() {
				if (!this.processForm.feedbackText?.trim()) {
					return this.$message.warning("请填写处理备注")
				}
				try {
					this.loginOpen("提交处理...")
					await this.API.post(this.API.fileurl.postSuggestHandle, this.processForm)
					this.$message.success("处理成功")
					this.dialogVisible = false
					this.fetchList(false)
				} catch (e) {
					console.error(e)
				} finally {
					this.noLogin()
				}
			},
			getTypeName(val) {
				const map = {
					"FUNCTION": "功能建议",
					"BUG": "BUG问题",
					"OPTIMIZE": "体验优化",
					"OTHER": "其他"
				}
				return map[val] || val || "--"
			},
			// 平台类型映射
			getUserTypeName(val) {
				const map = {
					"2": "学校",
					"3": "学生",
					"4": "家长",
					"5": "教育局"
				}
				return map[val] || val || "--"
			},
			getStatusName(v) {
				const map = {
					0: "已提交",
					1: "处理中",
					10: "处理完成",
					99: "进入需求库"
				}
				return map[v] || "未知"
			},
			getStatusTag(v) {
				const map = {
					0: "warning",
					1: "primary",
					10: "success",
					99: "info"
				}
				return map[v] || ""
			},
			formatTs(ts) {
				if (!ts) return "--"
				let t = Number(ts)
				if (t.toString().length === 10) t *= 1000
				const d = new Date(t)
				const pad = n => n < 10 ? "0" + n : n
				return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 20000
				})
			},
			noLogin() {
				if (this.login) {
					this.login.close()
					this.login = null
				}
			}
		}
	}
</script>

<style scoped>
	.feedback-page {
		padding: 16px;
	}

	.mt16 {
		margin-top: 16px;
	}

	pre {
		font-family: inherit;
	}
</style>